import { ComponentPropsWithoutRef } from 'react'
import clsx from 'clsx'

import styles from './Section.module.scss'

type SectionProps = ComponentPropsWithoutRef<'section'> & {
  $padding?: 'none' | 'medium'
}

export const Section = ({
  $padding = 'none',
  className,
  ...props
}: SectionProps) => (
  <section
    className={clsx(
      styles.section,
      { [styles.paddingNone]: $padding === 'none' },
      className
    )}
    {...props}
  />
)

export const StrongText = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'strong'>) => (
  <strong className={clsx(styles.strongText, className)} {...props} />
)
